type CallsignDialogMode = "join" | "edit";

type CallsignDialogProps = {
  mode: CallsignDialogMode;
  draft: string;
  error: string | null;
  canSubmit: boolean;
  isSubmitting: boolean;
  connectionState: "idle" | "connecting" | "connected" | "disconnected";
  onDraftChange: (next: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
};

export const CallsignDialog = ({
  mode,
  draft,
  error,
  canSubmit,
  isSubmitting,
  connectionState,
  onDraftChange,
  onSubmit,
  onCancel
}: CallsignDialogProps) => {
  const isJoin = mode === "join";
  const title = isJoin ? "Enter session" : "Edit callsign";
  const helpText = isJoin
    ? "Choose a unique callsign before joining this shared session."
    : "Update your callsign for this session.";

  return (
    <div className="callsign-modal" role="dialog" aria-modal="true" aria-labelledby="callsign-title">
      <form
        className="callsign-modal-card"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <h2 id="callsign-title">{title}</h2>
        <p className="muted">{helpText}</p>
        <div className="input-group">
          <label htmlFor="callsign-input">Callsign</label>
          <input
            id="callsign-input"
            value={draft}
            onChange={(event) => onDraftChange(event.target.value)}
            autoFocus
          />
        </div>
        {error ? <p className="error">{error}</p> : null}
        {connectionState !== "connected" && (
          <p className="muted">
            {connectionState === "connecting"
              ? "Connecting to session..."
              : connectionState === "disconnected"
                ? "Connection lost. Reconnecting..."
                : "Waiting for session connection..."}
          </p>
        )}
        <div className="button-row">
          <button
            className="primary"
            type="submit"
            disabled={!canSubmit || isSubmitting}
          >
            {isSubmitting
              ? isJoin
                ? "Joining..."
                : "Saving..."
              : isJoin
                ? "Enter session"
                : "Save callsign"}
          </button>
          {!isJoin && (
            <button className="ghost" type="button" onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};
